import { Label } from "@roberttamas/ui";
import type { ReactNode } from "react";

/**
 * A guided form field: label, an optional one-line description above
 * the control (so it reads before typing), then the control and any
 * dynamic feedback as children.
 */
export function Field({
  label,
  htmlFor,
  description,
  children,
}: {
  label: string;
  htmlFor?: string;
  description?: string;
  children: ReactNode;
}) {
  return (
    <div className="space-y-2">
      <div className="space-y-0.5">
        <Label htmlFor={htmlFor} className="text-base">
          {label}
        </Label>
        {description && (
          <p className="text-sm text-muted-foreground">{description}</p>
        )}
      </div>
      {children}
    </div>
  );
}
